import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import musicPlayer from "../../Assets/Projects/musicPlayer.png";
import search from "../../Assets/Projects/search.png";
import lena from "../../Assets/Projects/lena.png";
// import flower from "../../Assets/Projects/flower.png";
import tiket4t from "../../Assets/Projects/ticket4t.png";
import monitor from "../../Assets/Projects/monitor.png";
import slangword from "../../Assets/Projects/slangword.png";
import bookingfood from "../../Assets/Projects/bookingfood.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Below are some of the projects I have worked on during my time at
          school.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tiket4t}
              isBlog={false}
              title="Ticket4T"
              subject="Web Application Development"
              description="Ticket4T is an online ticket booking website aimed at providing customers with a simple and convenient ticket booking experience."
              ghLink="https://github.com/NgocTien0110/Ticket4T"
              demoLink="https://project-ticket4t-nhom5.onrender.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bookingfood}
              isBlog={false}
              title="Booking food online"
              subject="Database Management System"
              description="The application has user modules for partners, customers, drivers, employees, and administrators. Partners manage chain stores, customers can order food, drivers deliver the orders, employees manage partners and contracts, and the administrator manages all user groups."
              ghLink="https://github.com/NgocTien0110/Project-Booking-Food-Online-DBMS"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={slangword}
              isBlog={false}
              title="Slang word"
              subject="Java Application Development"
              description="The main goal of this project is to focus on Java IO, Object-oriented Programming, Generic, and Collections concepts, while building a Slang Dictionary application."
              ghLink="https://github.com/NgocTien0110/A-CLIENT-MONITORING-SYSTEM"
              demoLink="https://www.youtube.com/watch?v=k96VdcADKXY"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={monitor}
              isBlog={false}
              title="A client monitoring system"
              subject="Java Application Development"
              description="A file directory monitoring application for client machines can be developed using Java programming language with a graphical user interface (GUI), network processing, and multi-threading capabilities."
              ghLink="https://github.com/NgocTien0110/A-CLIENT-MONITORING-SYSTEM"
              demoLink="https://www.youtube.com/watch?v=2aAT5BzWeL8&t=2s"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={search}
              isBlog={false}
              title="Search Algorithms"
              subject="Introduction to Artificial Intelligence"
              description="Simulate search algorithms: Breadth First Search,
              Uniform Cost Search, 
              Iterative Deepening Search, 
              A Start Search, 
              Greedy Best First Search in the maze."
              ghLink="https://github.com/NgocTien0110/Artificial-Intelligence-Lab-1"
              // demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={musicPlayer}
              isBlog={false}
              title="Music player"
              subject="Introduction to Software Engineering"
              description="Build a music website with basic functions such as: play/pause, 
              increase/decrease volume, create playlists, play random music, ... (Get music from ZingMP3)"
              ghLink="https://github.com/ntp-shin/Music_Player_Group5"
              // demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lena}
              isBlog={false}
              title="Image Processing"
              subject="Applied Mathematics and Statistics"
              description="Adjust Brightness, 
              Adjust Contrast, 
              Flip the image (Vertical / Horizontal), 
              Convert RGB image to grayscale image, 
              Blend 2 images of the same size, 
              Blur the image, 
              Circular mask, 
              Ellipse mask"
              ghLink="https://github.com/NgocTien0110/Applied-Mathematics-and-Statistics/tree/main/lab3_project2"
              // demoLink=""
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={flower}
              isBlog={false}
              title="Flowers"
              description="Using pillow, matplotlib, numpy libraries and math formulas design and create beautiful flowers."
              ghLink="https://github.com/NgocTien0110/Flowers"
              // demoLink=""
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
